import { ModelParameter } from "./mlModel-parameters.model";

export class MlModel{
  modelId: number;
  modelName: string;
  modelApiVersion: number;
  businessDescription: string;
  modelType: string;
  businessFunctionType: number;
  providerInformation: string;
  lastUpdatedDate: Date | string;
  createdBy: string;
  lastUpdatedBy: string;
  refineryName: string;
  ModelContainerId: string;
  ModelContainerUrl: string;
  apiUrl: string;
  modelEntityType: string;
  inputParameters: ModelParameter[];
  outputParameters: ModelParameter[];
  baseModelId;
  modelConfigrationId;
  tenantId: number;

  constructor() {
    this.modelId = 0;
    this.modelName = '';
    this.modelApiVersion = 0;
    this.businessDescription = '';
    this.modelType = '';
    this.businessFunctionType = 0;
    this.providerInformation = '';
    this.lastUpdatedDate = new Date();
    this.createdBy = '';
    this.lastUpdatedBy = '';
    this.refineryName = '';
    this.ModelContainerId = '';
    this.ModelContainerUrl = '';
    this.apiUrl = '';
    this.modelEntityType = '';
    this.inputParameters = [];
    this.outputParameters = [];
    this.baseModelId = '';
    this.modelConfigrationId = '';
    this.tenantId = 0;
  }
}
